import React, { useState } from "react";
import axios from "axios";

const AddressAutocomplete = ({ onSelect }) => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const handleChange = async (e) => {
    const value = e.target.value;
    setQuery(value);

    // Ne lance pas la recherche avant 3 caractères
    if (value.length < 3) {
      setSuggestions([]);
      return;
    }

    try {
      const { data } = await axios.get(
        "https://api-adresse.data.gouv.fr/search/",
        { params: { q: value, limit: 5 } }
      );
      setSuggestions(data.features);
    } catch (err) {
      console.error("Erreur auto-complétion adresse :", err);
    }
  };

  const handleSelect = (feature) => {
    const props = feature.properties;
    const coords = feature.geometry.coordinates;

    const selected = {
      label: props.label,
      city: props.city || props.municipality || props.context?.split(",")?.[0]?.trim() || "",
      postcode: props.postcode,
      lat: coords[1],
      lng: coords[0],
    };

    setQuery(selected.label);
    setSuggestions([]);
    onSelect(selected);
  };

  return (
    <div className="autocomplete-wrapper">
      <input
        type="text"
        value={query}
        onChange={handleChange}
        placeholder="Commencez à saisir une adresse..."
        className="autocomplete-input"
      />

      {suggestions.length > 0 && (
        <ul className="autocomplete-container">
          {suggestions.map((s, i) => (
            <li
              key={i}
              className="autocomplete-item"
              onClick={() => handleSelect(s)}
            >
              {s.properties.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AddressAutocomplete;
